<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Enter PIN</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!successMessage">
    <form (ngSubmit)="handleSubmit()">
      <div class="form-group">
        <input type="password" class="form-control" id="pinInput" name="pinInput" required
               ngbautofocus
               [(ngModel)]="pinInput" (ngModelChange)="onPinChange()">
      </div>
      <button type="submit" class="btn btn-block btn-primary"
              [class.disabled]="!canSubmitPin()"
              [disabled]="!canSubmitPin()">
        {{ loadingStaffMember ? 'Loading...' : 'Submit PIN' }}
      </button>
    </form>
    <div class="alert alert-danger mt-3" role="alert" *ngIf="staffMemberNotFound">
      This PIN does not match any staff account. Please try entering your PIN again or speak to an administrator.
    </div>
  </div>

</ng-container>
